export default __webpack_public_path__ + "static/media/motion_icon-cluster.2e9988fe.svg";